import Job from '../job';

/**
 * Create the action
 */

const { thunk, request, success, error } = Job.index((fetch) =>
    fetch.get('job')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
